import { ConfigurationsEffects } from './configurations/configurations.effects';
import { configurationsReducer } from './configurations/configurations.reducer';
import { DemandForecastStateEffects } from './demand-forecasting.effects';
import { FilterEffects } from './filter/filter.effects';
import { filterReducer } from './filter/filter.reducer';
import { ForecastSeriesEffects } from './forecast-series/forecast-series.effects';
import { forecastSeriesReducer } from './forecast-series/forecast-series.reducer';
import { ForecastVersionEffects } from './forecast-version/forecast-version.effects';
import { forecastVersionReducer } from './forecast-version/forecast-version.reducer';

export const demandForecastingReducer = {
  configurations: configurationsReducer,
  filter: filterReducer,
  forecastSeries: forecastSeriesReducer,
  forecastVersion: forecastVersionReducer,
};
export const demandForecastingEffects = [
  DemandForecastStateEffects,
  ConfigurationsEffects,
  ForecastVersionEffects,
  ForecastSeriesEffects,
  FilterEffects,
];
